import { Paper, Stack, Typography } from "@mui/material";
import { CommsTemplateContent } from "./comms-template-content";
import { CommsTemplateImages } from "./comms-template-images";

import type { ContentTone } from "../brand-kit/server/brand-kit-service";
import type { FC } from "react";

interface CommsTemplatePreviewProps {
  contentTone: ContentTone | "custom";
  onContentToneChange: (value: ContentTone | "custom") => void;
}

export const CommsTemplatePreview: FC<CommsTemplatePreviewProps> = ({
  contentTone,
  onContentToneChange,
}) => (
  <Stack direction="column" mt={2}>
    <Typography variant="subtitle2" color="text.primary">
      Image options
    </Typography>
    <Typography variant="body2" pb={2} color="text.primary">
      Select an option to preview it alongside the text we have generated.
    </Typography>
    <CommsTemplateImages mb={4} />
    <Typography variant="subtitle2" color="text.primary">
      Communication preview
    </Typography>
    <Typography variant="body2" pb={2} color="text.primary">
      Please check how your selected image looks with the generated text.{" "}
      <strong>You will be able to edit it in the next step.</strong>
    </Typography>
    <Paper
      elevation={1}
      sx={(theme) => ({
        px: 2,
        bgcolor: theme.palette.background.paper,
      })}
    >
      <CommsTemplateContent contentTone={contentTone} onContentToneChange={onContentToneChange} />
    </Paper>
  </Stack>
);
